import { render, staticRenderFns } from "./Step04Sender.vue?vue&type=template&id=33566012"
import script from "./Step04Sender.vue?vue&type=script&lang=js"
export * from "./Step04Sender.vue?vue&type=script&lang=js"
import style0 from "./Step04Sender.vue?vue&type=style&index=0&id=33566012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports